/**
 * Citizen setup — the one screen between sign-up and the citizen's first
 * destination. (Citizen first run · Lucas's A2 ①, with the city D-2 added)
 *
 * Two answers and nothing else: the country the citizen is leaving and the
 * city they live in. Both are canonical profile columns
 * (`talents.current_country`, `talents.current_city`) and two of the six the
 * CheckUp score needs, so nothing asked here is asked again later. The
 * destination is not an input: it is Portugal, or the invitation's.
 *
 * Shared by the web form (react-hook-form resolver), the mobile screen and the
 * API's `POST /users/me/setup`, so the three validate one rule. Messages are
 * i18n keys, rendered by the client with `t()`.
 */
import { z } from 'zod';

import { countryCodeSchema } from '../validators';

/** `talents.current_city` is varchar(100). Refused at the edge, never truncated. */
export const CITY_MAX_LENGTH = 100;

export const citizenSetupSchema = z.object({
  // Empty first, so an unanswered select says "choose one" rather than the
  // format rule's "must be 2 characters (ISO 3166-1 alpha-2)".
  currentCountry: z.string().min(1, 'validation.originCountry.required').pipe(countryCodeSchema),
  currentCity: z
    .string()
    .trim()
    .min(1, 'validation.city.required')
    .max(CITY_MAX_LENGTH, 'validation.city.tooLong'),
});

export type CitizenSetupInput = z.infer<typeof citizenSetupSchema>;
